import React from 'react';
// Importamos de 24/outline solo para el ClockIcon
import { ClockIcon as HeroClockOutline } from '@heroicons/react/24/outline';

// Importamos de 20/solid para los demás
import {
  ChevronRightIcon as HeroChevronRight,
  ChevronLeftIcon as HeroChevronLeft,
  MagnifyingGlassIcon as HeroSearch,
  HomeIcon as HeroHome,
  UsersIcon as HeroUsers,
  Cog6ToothIcon as HeroSettings,
} from '@heroicons/react/20/solid';

/**
 * Props comunes para los iconos
 */
interface IconProps {
  className?: string;
}

/**
 * Icono Chevron Right (apunta hacia la derecha)
 * Usado en el botón de collapse
 */
export const ChevronRightIcon: React.FC<IconProps> = ({ className = 'size-5' }) => (
  <HeroChevronRight className={className} aria-hidden="true" />
);

/**
 * Icono Chevron Left (apunta hacia la izquierda)
 * Usado en el botón de expand
 */
export const ChevronLeftIcon: React.FC<IconProps> = ({ className = 'size-5' }) => (
  <HeroChevronLeft className={className} aria-hidden="true" />
);

/**
 * Icono Clock (reloj) - Estilo OUTLINE 24
 * Usado en el botón "Recientes"
 */
export const ClockIcon: React.FC<IconProps> = ({ className = 'size-5' }) => (
  <HeroClockOutline className={className} aria-hidden="true" />
);

/**
 * Icono Magnifying Glass (búsqueda)
 * Usado en el botón de búsqueda
 */
export const MagnifyingGlassIcon: React.FC<IconProps> = ({ className = 'size-5' }) => (
  <HeroSearch className={className} aria-hidden="true" />
);

/**
 * Icono Home
 * Ejemplo para items de navegación
 */
export const HomeIcon: React.FC<IconProps> = ({ className = 'size-5' }) => (
  <HeroHome className={className} aria-hidden="true" />
);

/**
 * Icono Users
 * Ejemplo para items de navegación
 */
export const UsersIcon: React.FC<IconProps> = ({ className = 'size-5' }) => (
  <HeroUsers className={className} aria-hidden="true" />
);

/**
 * Icono Settings
 * Ejemplo para items de navegación
 */
export const SettingsIcon: React.FC<IconProps> = ({ className = 'size-5' }) => (
  <HeroSettings className={className} aria-hidden="true" />
);
